/* © 2026 EXOLOX, INC. Compact brand navigation. */
(() => {
  if (window.EXOBrandOrbit?.initialize) return;
  const projects = {
  "configure": {
    "title": "Turn product engineering into a live experience.",
    "copy": "Let customers explore the model, choose the details and see their product take shape. We connect geometry, materials and artwork to options that make sense together.",
    "chain": "Interactive 3D, configuration rules and front/back artwork controls—built around the real product and carried into the buying experience.",
    "brands": [
      "gameday",
      "os",
      "exo_hdw"
    ],
    "route": "exo-general"
  },
  "commerce": {
    "title": "Build the way people explore and buy.",
    "copy": "Connect the configurator to product pages, collections and ordering. Keep the experience clear from the first click through the customer’s final selection.",
    "chain": "Live storefront development, product data, saved configurations and commerce workflows. One product experience, from discovery to order.",
    "brands": [
      "os",
      "gameday",
      "rolypulley"
    ],
    "route": "exo-general"
  },
  "launch": {
    "title": "Launch the product and its story together.",
    "copy": "Carry one product system across the storefront, campaign and retail display. Show what makes it different and give customers a direct way to make it their own.",
    "chain": "Product renders, useful content, campaign assets and interactive demos—connected to the configurator and the path to purchase.",
    "brands": [
      "gameday",
      "virtus",
      "os"
    ],
    "route": "exo-general"
  },
  "catalog": {
    "title": "Keep the product and the catalog connected.",
    "copy": "Build reusable models, options and artwork tools that can work across a product family. Update the experience as the product develops, without rebuilding every variation.",
    "chain": "Shared 3D assets, product specifications and release workflows. Manufacturing and supply partners support the engineered product behind the storefront.",
    "brands": [
      "os",
      "gameday",
      "exo_hdw"
    ],
    "route": "exo-os"
  }
};
  function initializeBrandOrbit(section) {
    if (!section || section.dataset.orbitReady === 'true') return;
    const items = [...section.querySelectorAll('[data-orbit-item]')];
    const icons = [...section.querySelectorAll('[data-orbit-focus]')];
    const rail = section.querySelector('[data-orbit-rail]');
    const picker = section.querySelector('[data-orbit-select]');
    const related = section.querySelector('[data-project-brands]');
    const needs = [...section.querySelectorAll('[data-orbit-need]')];
    const status = section.querySelector('[data-orbit-status]');
    if (!items.length || !rail || icons.length !== items.length) return;
    let activeIndex = -1;
    section.dataset.orbitReady = 'true';
    const focusItem = index => {
      if (index < 0 || index >= items.length || index === activeIndex) return;
      if (activeIndex >= 0) {
        items[activeIndex].hidden = true;
        items[activeIndex].classList.remove('is-active');
        icons[activeIndex].setAttribute('aria-pressed', 'false');
      }
      activeIndex = index;
      const item = items[index];
      item.hidden = false;
      item.classList.add('is-active');
      icons[index].setAttribute('aria-pressed', 'true');
      item.querySelectorAll('img.brand-panel__image').forEach(image => { image.loading = 'eager'; });
      if (picker) picker.value = String(index);
      if (status) status.textContent = item.dataset.orbitName;
      related?.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.index) === index)));
    };
    const move = direction => focusItem((activeIndex + direction + items.length) % items.length);
    const chooseProject = key => {
      const project = projects[key]; if (!project) return;
      needs.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.orbitNeed === key)));
      for (const [selector,value] of [['[data-project-title]',project.title],['[data-project-copy]',project.copy],['[data-project-chain]',project.chain]]) {
        const node=section.querySelector(selector); if(node) node.textContent=value;
      }
      const contact=section.querySelector('[data-project-contact]'); if(contact) contact.href='/pages/contact?route='+project.route;
      if (related) {
        related.replaceChildren();
        project.brands.forEach(brand => {
          const index=items.findIndex(item=>item.dataset.orbitBrand===brand); if(index<0)return;
          const button=document.createElement('button'); button.type='button';
          button.textContent=items[index].dataset.orbitName+' ↗'; button.dataset.index=String(index); button.dataset.brand=brand;
          button.setAttribute('aria-pressed',String(index===activeIndex)); button.setAttribute('aria-label','Explore '+items[index].dataset.orbitName+' in the viewer');
          button.addEventListener('click',()=>focusItem(index)); related.append(button);
        });
      }
      focusItem(project.brands.map(brand=>items.findIndex(item=>item.dataset.orbitBrand===brand)).find(index=>index>=0) ?? 0);
    };
    icons.forEach((button,index) => {
      button.addEventListener('click',()=>focusItem(index));
      button.addEventListener('keydown',event=>{
        let target=index;
        if(event.key==='ArrowRight')target=(index+1)%items.length;
        else if(event.key==='ArrowLeft')target=(index+items.length-1)%items.length;
        else if(event.key==='Home')target=0;
        else if(event.key==='End')target=items.length-1;
        else return;
        event.preventDefault();focusItem(target);icons[target].focus();
      });
    });
    section.querySelectorAll('[data-orbit-previous]').forEach(button=>button.addEventListener('click',()=>{
      move(-1);items[activeIndex].querySelector('[data-orbit-previous]').focus({preventScroll:true});
    }));
    section.querySelectorAll('[data-orbit-next]').forEach(button=>button.addEventListener('click',()=>{
      move(1);items[activeIndex].querySelector('[data-orbit-next]').focus({preventScroll:true});
    }));
    // Preserve the existing homepage foundations' programmatic selection contract.
    if(picker){
      items.forEach((item,index)=>{const option=document.createElement('option');option.value=String(index);option.textContent=item.dataset.orbitName;picker.append(option);});
      picker.addEventListener('change',()=>focusItem(Number(picker.value)));
    }
    needs.forEach(button=>button.addEventListener('click',()=>chooseProject(button.dataset.orbitNeed)));
    chooseProject('configure');
    // No moving-card geometry, per-frame layout reads, resize handlers or animation loop.
  }
  function initialize(root=document){
    if(root.matches?.('[data-brand-orbit]'))initializeBrandOrbit(root);
    root.querySelectorAll?.('[data-brand-orbit]').forEach(initializeBrandOrbit);
  }
  window.EXOBrandOrbit={initialize};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initialize(),{once:true});else initialize();
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
  document.addEventListener('exo:brand-orbit:load',event=>initialize(event.detail?.root||document));
})();
